<organization-top-navbar></organization-top-navbar>
<div class="block pb-5 padding-top-2-5rem">
  <div class="lg:inline-block lg:px-28 md:py-4 padding-left-1-25rem">
    <button class="gap-2 flex items-center" (click)="(goToHomePage())">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="size-6 stroke-[#0D6EFD]">
        <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
      </svg>
      <p class=" font-medium text-sm text-[#0D6EFD]">{{ "PARKIFLY.BACK_BUTTONS.BACK_TO_START" | transloco }}</p>
    </button>
  </div>
  <div class="Content lg:px-28 px-4 justify-end items-start gap-8 w-full flex xl:flex-row flex-col mb-4">
    <div class="UppgifterWrapper  self-stretch flex-col justify-start items-start gap-4 inline-flex w-full">
      <div class="text-black text-lg font-bold  leading-[30px]">
        @if(this.booking?.organizationName?.toLowerCase() == "flygets.se" ||
        this.booking?.organizationName?.toLowerCase() == "skavsta" ||
        this.booking?.organizationName?.toLowerCase() == "quality hotel arlanda xpo parkering" ||
        this.booking?.organizationName?.toLowerCase() == "quality-xpo-arlanda" ||
        this.booking?.organizationName?.toLowerCase() == "aiden hotel arlanda parkering"||
        this.booking?.organizationName?.toLowerCase() == "aiden"
        ){
        {{ (site?.toLowerCase() === 'flygets' ? "PARKIFLY.CONFIRMATION.HI" : "PARKIFLY.SKAVSTA.HI") | transloco }}
        {{ this.booking?.firstName }}!
        {{ (site?.toLowerCase() === 'flygets' ? "PARKIFLY.CONFIRMATION.THANKS_FOR_PARKING" :
        "PARKIFLY.SKAVSTA.RECEIVED_BOOKING") |
        transloco }}.
        }
        @else if(this.booking?.organizationName?.toLowerCase() == "tui" || this.booking?.organizationName?.toLowerCase()
        == "nazar" || this.booking?.organizationName?.toLowerCase() == "ving"){
        {{"PARKIFLY.SKAVSTA.HI" | transloco}}!
        {{ "PARKIFLY.CONFIRMATION.THANKS_FOR_PARKING" | transloco }}.
        }
      </div>
      <div
        class="self-stretch p-8 bg-indigo-50 rounded-[20px] justify-start items-start flex md:flex-row flex-col gap-2.5 mt-[6px]">
        <div class="grow shrink basis-0 flex-col justify-start items-start gap-4 inline-flex">
          <div class="justify-start items-start gap-2.5 inline-flex">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="24" height="24" rx="12" fill="#34C759" />
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M17.096 7.38967L9.93602 14.2997L8.03602 12.2697C7.68602 11.9397 7.13602 11.9197 6.73602 12.1997C6.34602 12.4897 6.23602 12.9997 6.47602 13.4097L8.72602 17.0697C8.94602 17.4097 9.32601 17.6197 9.75601 17.6197C10.166 17.6197 10.556 17.4097 10.776 17.0697C11.136 16.5997 18.006 8.40967 18.006 8.40967C18.906 7.48967 17.816 6.67967 17.096 7.37967V7.38967Z"
                fill="white" />
            </svg>
            <div class="text-neutral-800 text-base font-bold  leading-normal">
              {{ parkingOrder?.parking}}
              {{"PARKIFLY.CONFIRMATION.LONG_TIME_PARKING" | transloco}}</div>
          </div>
          @if(!isParkingPermitUser){
          <div class="flex-col justify-start items-start gap-2.5 flex">
            <div class="flex-col justify-start items-start gap-2 flex">
              <div class="flex-col justify-start items-start gap-2.5 flex">
                <div><span class="text-neutral-800 text-sm font-normal  leading-[21px]">{{
                    "PARKIFLY.CONFIRMATION.EMAIL_SENT_TO"
                    | transloco }} </span><span
                    class="text-neutral-800 text-sm font-medium leading-[21px]">{{order?.customer?.email }}</span>
                </div>
              </div>
              <div><span class="text-neutral-800 text-sm font-normal  leading-[21px]">{{
                  "PARKIFLY.CONFIRMATION.GOT_NO_MAIL" |
                  transloco }} </span><span class="text-blue-600 text-sm font-bold  leading-[21px]">{{
                  "PARKIFLY.CONFIRMATION.CONTACT_US" | transloco }}</span></div>
            </div>
          </div>
          }@else{
          <div class="flex-col justify-start items-start gap-2.5 flex">
            <div class="flex-col justify-start items-start gap-2 flex">
              <div class="flex-col justify-start items-start gap-2.5 flex">
                <div><span class="text-sm font-semibold text-neutral-800 leading-[21px]">
                    {{ 'PARKING_PERMIT.RECEIPT_INFO_1' | transloco }}</span>
                </div>
              </div>
              <div><span class="text-neutral-800 text-sm font-semibold leading-[21px]">
                  {{ 'PARKING_PERMIT.RECEIPT_INFO_2' | transloco }}</span>
              </div>
            </div>
          </div>
          }
        </div>
        <div class="flex-col justify-start items-start gap-4 inline-flex">
          <div class="w-[209px] px-4 py-2 bg-white rounded-lg flex-col justify-center items-start gap-2.5 flex">
            <div><span class="text-neutral-800 text-sm font-normal  leading-[21px]">{{
                "PARKIFLY.CONFIRMATION.ORDER_NUMBER" |
                transloco }}</span><span class="text-neutral-800 text-sm font-medium  leading-[21px]">:
              </span><span class="text-neutral-800 text-sm font-bold  leading-[21px]"> {{bookingDetails.order?.orderNr
                }} </span>
            </div>
          </div>

          @if(optionsConfig?.pdf !== false) {
          <button
            class="self-stretch px-4 py-2 bg-[#FFC700] hover:bg-[#FFD833] rounded-lg justify-start items-center gap-2.5 inline-flex"
            (click)="(downloadPdf())">
            <div class="grow shrink basis-0 text-neutral-800 text-sm font-medium  leading-[21px]">{{
              "PARKIFLY.CONFIRMATION.DOWNLOAD_AS_PDF" | transloco }}
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-5">
              <path
                d="M10.75 2.75a.75.75 0 0 0-1.5 0v8.614L6.295 8.235a.75.75 0 1 0-1.09 1.03l4.25 4.5a.75.75 0 0 0 1.09 0l4.25-4.5a.75.75 0 0 0-1.09-1.03l-2.955 3.129V2.75Z" />
              <path
                d="M3.5 12.75a.75.75 0 0 0-1.5 0v2.5A2.75 2.75 0 0 0 4.75 18h10.5A2.75 2.75 0 0 0 18 15.25v-2.5a.75.75 0 0 0-1.5 0v2.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25v-2.5Z" />
            </svg>
          </button>
          }
        </div>
      </div>
      <div
        class="self-stretch h-[auto] p-8 rounded-[20px] border border-zinc-200 flex-col justify-start items-start gap-4 flex">
        <div class="text-neutral-800 text-lg font-bold  leading-[27px]">{{ "PARKIFLY.CONFIRMATION.CANCELLATION_POLICY" |
          transloco }}</div>
        <div class="self-stretch text-neutral-800 text-sm font-normal  leading-normal">{{
          "PARKIFLY.CONFIRMATION.FREE_CANCELLATION" | transloco }}</div>
      </div>
      <div
        class="self-stretch h-[auto] p-8 rounded-[20px] border border-zinc-200 flex-col justify-start items-start gap-4 flex">
        <div class="text-neutral-800 text-lg font-bold  leading-[27px]">{{ "PARKIFLY.CONFIRMATION.HANDLE_YOUR_BOOKING" |
          transloco }}</div>
        <div class="self-stretch text-neutral-800 text-sm font-normal  leading-normal">
          {{"PARKIFLY.CONFIRMATION.WANT_TO_CHANGE_BOOKING" | transloco}} </div>
        <div class="text-blue-600 text-sm font-semibold leading-normal cursor-pointer hover:underline"
          (click)="goToHandleBookingForm()">{{"PARKIFLY.HOME.MANAGE_BOOKING" | transloco}}
        </div>
      </div>

      <div class="self-stretch p-8 rounded-[20px] border border-zinc-200 flex-col justify-start items-start gap-4 flex">
        <div class="text-neutral-800 text-lg font-bold  leading-[27px]">{{"PARKIFLY.CONFIRMATION.CONTACT_US" |
          transloco}}</div>
        <div class="self-stretch text-neutral-800 text-sm font-normal  leading-normal">
          {{"PARKIFLY.CONFIRMATION.GOT_QUESTIONS" |
          transloco}} </div>
        <div class="self-stretch">
          <span class="text-neutral-800 text-sm font-normal  leading-[21px]">{{"PARKIFLY.CONFIRMATION.PHONE" |
            transloco}}
          </span>
          @if(site?.toLowerCase() === 'flygets' || site?.toLowerCase() === 'nazar' || site?.toLowerCase() === 'tui') {
          <a href="tel:+46103300333" class="text-blue-600 text-sm font-bold leading-[21px] hover:underline">010-330 03
            33 </a>
          <div class="text-neutral-800 text-sm font-normal leading-[21px] inline-block">
            {{"PARKIFLY.CONFIRMATION.EXCHANGE_HOURS" | transloco}}
          </div>
          } @else if(site?.toLowerCase() === 'skavsta') {
          <a href="{{'PARKIFLY.SKAVSTA.PHONE_NUMBER' | transloco}}"
            class="text-blue-600 text-sm font-bold leading-[21px] hover:underline">{{"PARKIFLY.SKAVSTA.PHONE_NUMBER" |
            transloco}} </a>
          <div class="text-neutral-800 text-sm font-normal leading-[21px] inline-block">
            {{"PARKIFLY.CONFIRMATION.SKAVSTA.EXCHANGE_HOURS" | transloco}}
          </div>
          } @else if(site?.toLowerCase() === 'quality hotel arlanda xpo parkering' || site?.toLowerCase() ===
          'quality-xpo-arlanda' || site?.toLowerCase() === 'quality') {
          <a href="tel:+46859511113" class="text-blue-600 text-sm font-bold leading-[21px] hover:underline">08-595 111
            13 </a>
          } @else if(site?.toLowerCase() === 'aiden hotel arlanda parkering' || site?.toLowerCase() ===
          'aiden-short-term' || site?.toLowerCase() === 'aiden') {
          <a href="tel:+46103300333" class="text-blue-600 text-sm font-bold leading-[21px] hover:underline">010-330 03
            33 </a>
          }
        </div>
        <div class="self-stretch">
          <span class="text-neutral-800 text-sm font-normal  leading-[21px]">{{"PARKIFLY.CONFIRMATION.FIND_PARKING_SPOT"
            |
            transloco}} </span>
          @if(site?.toLowerCase() === 'flygets' || site?.toLowerCase() === 'nazar' || site?.toLowerCase() === 'tui' ||
          site?.toLowerCase() === 'ving' || site?.toLowerCase() === 'quality hotel arlanda xpo parkering' ||
          site?.toLowerCase() === 'quality' || site?.toLowerCase() === 'quality-xpo-arlanda' || site?.toLowerCase() ===
          'aiden hotel arlanda parkering' || site?.toLowerCase() === 'aiden-short-term' || site?.toLowerCase() ===
          'aiden') {
          <a href="https://maps.app.goo.gl/U66KQzY4ay26yvnA7" target="_blank">
            <span
              class="text-blue-600 text-sm font-bold leading-[21px] hover:underline">{{"PARKIFLY.CONFIRMATION.GOOGLE_MAPS_LINK"
              |
              transloco}} </span>

          </a>
          }@else if(site?.toLowerCase() == 'skavsta') {
          <a [href]="googleMapsLink" target="_blank">
            <span
              class="text-blue-600 text-sm font-bold leading-[21px] hover:underline">{{"PARKIFLY.CONFIRMATION.GOOGLE_MAPS_LINK"
              |
              transloco}} </span>
          </a>
          }

        </div>
        <div class="self-stretch">
          <span class="text-neutral-800 text-sm font-normal  leading-[21px]">{{ "PARKIFLY.CONFIRMATION.EMAIL" |
            transloco }}:
          </span>
          @if(site?.toLowerCase() === 'flygets' || site?.toLowerCase() === 'nazar' || site?.toLowerCase() === 'tui') {
          <a href="mailto:info@flygets.se"
            class="text-blue-600 text-sm font-bold  leading-[21px] hover:underline">info&#64;flygets.se</a>
          } @else if(site?.toLowerCase() === 'skavsta') {
          <a href="{{'SKAVSTA.EMAIL_ADDRESS1' | transloco}}"
            class="text-blue-600 text-sm font-bold leading-[21px] hover:underline">{{"PARKIFLY.SKAVSTA.EMAIL_ADDRESS1"
            |
            transloco}}</a>
          } @else if(site?.toLowerCase() === 'quality hotel arlanda xpo parkering' || site?.toLowerCase() ===
          'quality-xpo-arlanda' || site?.toLowerCase() === 'quality') {
          <a href="mailto:q.arlanda@strawberry.se"
            class="text-blue-600 text-sm font-bold leading-[21px] hover:underline">q.arlanda&#64;strawberry.se</a>
          } @else if(site?.toLowerCase() === 'aiden hotel arlanda parkering' || site?.toLowerCase() ===
          'aiden-short-term' || site?.toLowerCase() === 'aiden') {
          <a href="mailto:aiden@parkifly.com"
            class="text-blue-600 text-sm font-bold leading-[21px] hover:underline">aiden&#64;parkifly.com</a>
          }
        </div>
      </div>
    </div>

    <div class="flex-col w-full basis-1/3">
      <app-booking-summary-card [booking]="booking" [bookingDetails]="bookingDetails"></app-booking-summary-card>
    </div>
  </div>

</div>